import { render } from "./PicnicGame.vue?vue&type=template&id=0d59fd78&scoped=true&ts=true"
import script from "./PicnicGame.vue?vue&type=script&lang=ts"
export * from "./PicnicGame.vue?vue&type=script&lang=ts"

import "./PicnicGame.vue?vue&type=style&index=0&id=0d59fd78&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d59fd78"]])

export default __exports__